import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LimitApplicationsService } from '../../services/limit-applications.service';
import { AuthService } from '../../services/auth.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-limit-application-details',
  templateUrl: './limit-application-details.component.html',
  styleUrls: ['./limit-application-details.component.css'],
})
export class LimitApplicationDetailsComponent implements OnInit {
  appId: string;
  appdetails: any;
  dataRec: any;
  user: any;

  showApproveForm: boolean = false;
  submitting: boolean = false;

  showFolders: boolean = true;
  showFolderFiles: boolean = false;
  activeFolder: { name: string; keyword: string; docTypes?: any[] };

  limitForm: FormGroup = this.fb.group({
    approvedLimit: [
      '',
      [
        Validators.required,
        Validators.min(1),
        this.validateApprovedLimit.bind(this),
      ],
    ],
    tenurePeriod: [null, [Validators.required, Validators.min(1)]],
    tenureUom: ['', [Validators.required]],
    tenureStart: [
      null,
      [Validators.required, this.validateTenureDate.bind(this)],
    ],
    tenureEnd: [],
  });

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private limitAppService: LimitApplicationsService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.appId = params.get('id');
    });
  }

  validateApprovedLimit(control: FormControl) {
    if (!this.appdetails) return;

    const { value } = control;

    if (value > this.appdetails.requestedLimit) {
      return {
        exceedRequestLimit: true,
      };
    }

    return null;
  }

  validateTenureDate(control: FormControl) {
    const { value } = control;

    const today = moment().format('YYYY-MM-DD');
    if (today > value) {
      return {
        beforeToday: true,
      };
    }

    return null;
  }

  ngOnInit() {
    this.user = this.auth.user;
    this.getData();
  }

  getData() {
    this.limitAppService.getLimitApplicationDetails(this.appId).subscribe(
      (data: any) => {
        this.dataRec = true;
        this.appdetails = data.data;
        console.log(data);
      },
      (err) => {
        this.toastr.error('Error occurred. Please try again.');
      }
    );
  }

  onSeeLimitDocuments() {
    $('#limit-docs-modal').modal('show');
    this.showFolders = true;
    this.showFolderFiles = false;
  }

  onFolderClick(folder) {
    this.showFolders = false;
    this.showFolderFiles = true;

    const { traderDocuments = [] } = this.appdetails.submittedBy;
    const docTypes = traderDocuments.filter(
      (file) => file.category === folder.keyword
    );

    this.activeFolder = { ...folder, docTypes };
  }

  onBackButtonClick() {
    this.showFolders = true;
    this.showFolderFiles = false;
  }

  onApproveClick() {
    this.showApproveForm = true;

    if (this.user && this.user.userType === 'bankUser') {
      const { makerRecommendations } = this.appdetails;

      if (!makerRecommendations) return;
      const {
        approvedLimit,
        tenurePeriod,
        tenureUom,
        tenureStart,
      } = makerRecommendations;

      this.limitForm.patchValue({
        approvedLimit: approvedLimit,
        tenurePeriod: tenurePeriod,
        tenureUom: tenureUom,
        tenureStart: moment(tenureStart).format('YYYY-MM-DD'),
      });
    }
  }

  onRejectClick() {
    $('#reject-modal').modal('show');
  }

  onRejectAccept() {
    this.submitting = true;

    this.limitAppService.reject(this.appId).subscribe(
      () => {
        $('#reject-modal').modal('hide');
        this.submitting = false;
        window.location.reload();
      },
      (err) => {
        this.submitting = false;
        this.toastr.error('Something went wrong');

        console.log(err);
      }
    );
  }

  onRejectCancel() {
    $('#reject-modal').modal('hide');
  }

  onCancelClick() {
    this.limitForm.reset();
    this.showApproveForm = false;
  }

  makerApprove() {
    this.limitAppService
      .approveByMaker(this.appId, this.limitForm.value)
      .subscribe(
        () => {
          $('#approve-modal').modal('hide');
          this.submitting = false;
          window.location.reload();
        },
        (err) => {
          this.submitting = false;
          this.toastr.error('Something went wrong');

          console.log(err);
        }
      );
  }

  checkerApprove() {
    this.limitAppService
      .approveByChecker(this.appId, this.limitForm.value)
      .subscribe(
        () => {
          $('#approve-modal').modal('hide');
          this.submitting = false;
          window.location.reload();
        },
        (err) => {
          this.submitting = false;
          this.toastr.error('Something went wrong');

          console.log(err);
        }
      );
  }

  onLimitSubmit() {
    $('#approve-modal').modal('show');
  }

  onApproveAccept() {
    this.submitting = true;
    // As we are considering the start for the duration of the tenure
    // and moment excluded the passed date while adding period
    const tenureEnd = moment(this.limitForm.get('tenureStart').value)
      .add(
        this.limitForm.get('tenurePeriod').value,
        this.limitForm.get('tenureUom').value
      )
      .subtract(1, 'day')
      .format('YYYY-MM-DD');
    this.limitForm.setValue({
      ...this.limitForm.value,
      tenureEnd,
    });

    if (this.user.userType === 'bankSubUser') {
      this.makerApprove();
    } else if (this.user.userType === 'bankUser') {
      this.checkerApprove();
    }
  }

  onApproveCancel() {
    $('#approve-modal').modal('hide');
  }

  goBack() {
    this.router.navigateByUrl('/limitapplications');
  }
}
